import {
	Button,
	InputWithLabel,
	Modal,
	TextInput,
	useModal,
	cn
} from 'crunch-components';
import { FunctionComponent } from 'react';
import { Controller, useForm } from 'react-hook-form';

interface Props {
	defaultTitle: string;
	onSubmit: (title: string) => void;
}

const RenameInventoryAllocationModal: FunctionComponent<Props> = ({
	defaultTitle,
	onSubmit,
}) => {
	const { close } = useModal();
	const { formState, control, handleSubmit } = useForm({
		defaultValues: {
			title: defaultTitle,
		},
	});

	function onSubmitClick({ title }: { title: string }): void {
		onSubmit(title);
		if (close !== undefined) {
			close();
		}
	}

	return (
		<Modal.Root>
			<Modal.Content>
				<Modal.Title>Rename inventory allocation</Modal.Title>
				<form
					onSubmit={handleSubmit(onSubmitClick)}
					id="rename-inventory-allocation"
				>
					<InputWithLabel
						label="Title"
						htmlFor="title"
						labelClassName={cn(
							'w-64 mb-2 md:mb-0',
							formState?.errors?.title?.message && '-mt-5'
						)}
					>
						<Controller
							name="title"
							control={control}
							rules={{ required: 'Required field' }}
							render={({ field }) => (
								<TextInput
									id="title"
									className="w-full sm:w-64"
									value={field.value}
									onChange={field.onChange}
									error={formState?.errors?.title?.message}
									placeholder="Title"
									type="text"
									endAdornment={undefined}
									startAdornment={undefined}
									size="regular"
								/>
							)}
						/>
					</InputWithLabel>
				</form>
			</Modal.Content>
			<Modal.Actions>
				<div className="flex justify-between">
					<Button
						variant="secondary"
						onClick={() => {
							if (close !== undefined) {
								close();
							}
						}}
					>
						Cancel
					</Button>
					<Button
						type="submit"
						variant="primary"
						form="rename-inventory-allocation"
					>
						Rename
					</Button>
				</div>
			</Modal.Actions>
		</Modal.Root>
	);
};

export default RenameInventoryAllocationModal;
